import React, {Component} from 'react';
import _config from "./plugin-config";

class PluginsSpace extends Component {

    list = [];

    listenContentChange(){
        this.list.map(item=>{
            item.listenContentChange && item.listenContentChange();
        });
    }

    showData(data){
        this.list.map(item=>{
            item.showData && item.showData(data);
        });
    }

    render() {
        this.list = [];
        let pluginComponents = [];
        let width = 44;
        let height = 70;
        let marginRight = 20;
        let float = "right";
        let config = this.props.pluginsSpaceConfig || _config;
        config.map(plugin =>{
            let PluginComponent = require(`./${plugin}/${plugin}.js`).default;
            pluginComponents.push(<PluginComponent ref={item=> item && this.list.push(item)} dynamicParams={this.props.dynamicParams} float={float} editor={window.ueditor} width={width} height={height} style={{marginRight:marginRight}} />);
        });
        pluginComponents = pluginComponents.reverse();
        return (
            <div style={{width: (width + marginRight + 10 + 2) * pluginComponents.length - 1}}>
                {pluginComponents.map((plugin, index)=>{
                    return <div style={{float:"right"}} key={index}>{plugin}</div>
                })}
            </div>
        );
    }
}

export default PluginsSpace;
